// src/supplier/components/RequireSupplier.jsx
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSupplierAuth } from "../context/SupplierAuthContext";

export default function RequireSupplier() {
  const { isAuthenticated, loading } = useSupplierAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-neutral-50 dark:bg-neutral-900">
        <div className="text-sm text-neutral-500">Loading…</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/supplier/login" state={{ from: location }} replace />;
  }

  return <Outlet />;
}
